import { render, staticRenderFns } from "./accessPlan.vue?vue&type=template&id=bc6d667e"
import script from "./accessPlan.vue?vue&type=script&lang=js"
export * from "./accessPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports